import { deleteObject, ref } from "firebase/storage";
import { db, storage } from "../lib/firebase";
import { push, ref as refDB, remove, set } from "firebase/database";
import { renewToken } from "../actions/auth";
import axios from "../lib/axios";
import { LaunchError } from "../utils/errors";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";

import { store } from "../app/store";

export const getKeyDatabase = () => () => push(refDB(db, "/")).key;

export const removeImageStorageAndDB =
  (uid, pathStorage, pathRTDB, deleteRTDB) => async () => {
    try {
      const storageRef = ref(storage, `${pathStorage}${uid}`);
      await deleteObject(storageRef);
      if (pathRTDB && deleteRTDB) {
        const dbRef = refDB(db, pathRTDB);
        await remove(dbRef);
      }
      return true;
    } catch (error) {
      store.dispatch(
        LaunchError(error, false, [], {
          functionName: "removeImageStorageAndDB",
          capture: "exception",
        })
      );
      console.log(error);
    }
  };

export const saveUrl = (url, pathRTDB) => async () => {
  try {
    await set(refDB(db, pathRTDB), url);
  } catch (error) {
    store.dispatch(
      LaunchError(error, false, [], {
        functionName: "saveUrl",
        capture: "exception",
      })
    );
    console.log(error);
  }
};
export const startUploadFileAws =
  (file, mime, path, withAuth = true, disableVerificationMedia = false) =>
  async (dispatch) => {
    try {
      let token;
      if (withAuth) {
        token = await dispatch(renewToken());
      }

      const { data } = await axios({
        method: "post",
        data: {
          type: mime,
          path,
          fileName: file.name,
          disableVerificationMedia,
        },
        url: `${getCloudFunctionUrl(withAuth ? "generateAwsUploadUrl" : "generateAwsUploadUrlWithoutAuth")}/${
          withAuth ? "generateAwsUploadUrl" : "generateAwsUploadUrlWithoutAuth"
        }`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.ok) {
        let attempt = 0;
        const maxAttempts = 3;

        while (attempt < maxAttempts) {
          try {
            await axios({
              method: "put",
              data: file,
              url: data.url,
              headers: {
                "Content-Type": mime,
              },
            });
            return data.url.split("?")[0];
          } catch (error) {
            attempt++;
            if (attempt >= maxAttempts) {
              throw error;
            }
            // Optional: Add a small delay between attempts
            await new Promise((resolve) => setTimeout(resolve, 1000 * attempt));
          }
        }
      } else {
        return false;
      }
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startUploadFileAws",
          context: { fileName: file?.name, mime, path, withAuth },
          tags: { operation: "file_upload" },
        })
      );
      return false;
    }
  };

export const startDeleteFileAws =
  (id, pathStorage, pathRTDB, deleteRTDB) => async (dispatch) => {
    try {
      const token = await dispatch(renewToken());
      const { data } = await axios({
        method: "post",
        data: { id, path: pathStorage },
        url: `${getCloudFunctionUrl("deleteFileAws")}/deleteFileAws`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data.ok) {
        if (pathRTDB && deleteRTDB) {
          const dbRef = refDB(db, pathRTDB);
          await remove(dbRef);
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
      dispatch(
        LaunchError(error, true, [], {
          functionName: "startDeleteFileAws",
          context: { id, pathStorage, pathRTDB, deleteRTDB },
          tags: { operation: "file_delete" },
        })
      );
      return false;
    }
  };
